import styled from "styled-components"

import { Text } from "@minuthq/meatball-ui-react"

import { EventNotificationsSettings } from "src/components/Account/BillingPortal/NotificationSettings/EventNotificationSettings"
import { MarketingNotificationsSettings } from "src/components/Account/BillingPortal/NotificationSettings/MarketingNotificationsSettings"
import { DesktopNotificationsToggle } from "src/components/Notifications/DesktopNotificationsToggle"
import { useTranslate } from "src/i18n/useTranslate"
import { DocumentHead } from "src/router/DocumentHead"
import { DefaultBox } from "src/ui/Layout/DefaultBox"
import { spacing } from "src/ui/spacing"

export function NotificationSettings() {
  const { t, langKeys } = useTranslate()

  return (
    <DefaultBox>
      <DocumentHead title={t(langKeys.notifications)} />

      <Grid>
        <div>
          <HeaderBox>
            <Text variant="heading3">
              {t(langKeys.notifications_settings_events_title)}
            </Text>

            <Text variant="body" color="tertiary">
              {t(langKeys.notifications_settings_events_body)}
            </Text>
          </HeaderBox>

          <EventNotificationsSettings />
        </div>

        <div>
          <HeaderBox>
            <Text variant="heading3">
              {t(langKeys.notifications_settings_marketing_title)}
            </Text>
          </HeaderBox>

          <MarketingNotificationsSettings />
        </div>

        <div>
          <DesktopNotificationsToggle />
        </div>
      </Grid>
    </DefaultBox>
  )
}

const Grid = styled.div`
  display: grid;
  gap: ${spacing.XL2};
`

const HeaderBox = styled.div`
  margin-bottom: ${spacing.M};
`
